import { z } from 'zod';
export const objectIdSchema = z.string().regex(/^[a-f\d]{24}$/i, 'invalid id');
export const isoDate = z.string().datetime({ offset: true });
/** Whether `YYYY-MM-DD` is a day that exists (no 2026-00-10, no 2026-02-30). */
export function isCalendarDay(day) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day))
        return false;
    const [y, m, d] = day.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d;
}
/** A calendar day, `YYYY-MM-DD` (Brussels), for dates people enter; it must exist. */
export const isoDay = z.string().refine(isCalendarDay, 'invalid date');
export const emailSchema = z.string().trim().toLowerCase().email().max(254);
